class Place {
  private data: google.maps.places.Place
  constructor(data: google.maps.places.Place) {
    this.data = data
  }

  get id() {
    return this.data.id
  }

  get name() {
    return this.data.displayName
  }

  get formattedAddress() {
    return this.data.formattedAddress
  }

  get location() {
    return this.addressComponent('route')
  }

  get address() {
    return `${this.addressComponent('route', true)} ${this.addressComponent('street_number')}`
  }

  get city() {
    return this.addressComponent('locality')
  }

  get zipCode() {
    return this.addressComponent('postal_code')
  }

  get country() {
    return this.addressComponent('country')
  }

  get countryCode() {
    return this.addressComponent('country', true)?.toUpperCase()
  }

  get latitude() {
    return this.data.location?.lat()
  }
  get longitude() {
    return this.data.location?.lng()
  }

  private addressComponent(key: string, short: boolean = false) {
    const found = this.data.addressComponents?.find((item) => item.types.indexOf(key) >= 0)
    if (!found) return ''
    return short ? found.shortText : found.longText
  }
}

export default Place
